import { useContext } from 'react';
import { navigateV2 } from '../../../../common/utils/router';
import { Img, Tooltip, svgSprite } from '../../../../hybrid/wrappers';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import css from './OfficeActivity.module.scss';
import { skeleton } from './helpers';
import ProgressBar from '../../../../widgets/progressBarGT/ProgressBar';
import T, { t } from '../../../../common/components/T';
import classNames from 'classnames';
import { LangContext } from '../../../../common/decorators/Language';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import UserContext from '../../../../common/utils/getContext';

const RenderData = ({ activity, customCss = {} }) => {
    const { translation } = useContext(LangContext);
    const { marketingCurrency } = useContext(UserContext);
    let info = activity?.data;
    const activityCondition = info?.conditions?.activity;
    const percent = info?.activity
        ? 100
        : activityCondition?.personal_volume?.target <= activityCondition?.personal_volume?.value && info?.activity
        ? 100
        : (activityCondition?.personal_volume?.value / activityCondition?.personal_volume?.target) * 100;

    const transformActivityDate = (date) => {
        return date?.split(' ')[0];
    };
    const mobile = useWindowDimensions() < 768;

    const pvValue = <strong>{`400 ${marketingCurrency?.symbol}`}</strong>;
    return (
        <div className={classNames(css.block, customCss.block)}>
            <Tooltip
                compStyle={{ tooltipWrapCustom: { position: 'static' }, inner: { className: css.button } }}
                text={<T textName='store' defaultStr='Магазин' />}
                showModalTooltip={!mobile}
            >
                <button onClick={() => navigateV2('/store')} className={classNames('circleButton', css.buttonInner)}>
                    {svgSprite('cart-new', { className: css.buttonSvg })}
                </button>
            </Tooltip>
            <div className={css.progress}>
                <div className={css.progressBar} id='officeRankWrapper'>
                    <ProgressBar
                        config={{
                            width: 280,
                            height: 280,
                            percent,
                            strokeWidth: 20,
                            defaultColor: 'rgba(177, 138, 75, 0.10)',
                            progressColor: info?.activity
                                ? ['rgba(122, 166, 67, 1)', 'rgba(51, 80, 16, 1)']
                                : ['rgba(201, 201, 201, 1)', 'rgba(72, 72, 72, 1)'],
                            id: 'officeRank'
                        }}
                    />
                    <div className={css.info}>
                        <div className={css.icon}>
                            <Img
                                src={`/src/img/activity/${info?.activity ? 'activity-done' : 'activity-fail'}.png`}
                                className={classNames(css.iconSvg, 'activityShadow')}
                                alt={`Activity`}
                            />
                        </div>
                        <div className={css.infoLabel}>
                            <p>
                                <T textName='activity' defaultStr='Активность' page='/office' />
                            </p>
                        </div>
                        <p className={css.infoStatus}>
                            {/* костильне відображення залежність від умов (залежить від минулої активності) */}
                            {info?.activity ? (
                                // activityCondition?.personal_volume?.value >= activityCondition?.personal_volume?.target ? (
                                //     <span className={css.activityDoneColor}>
                                //         <T textName='completed' defaultStr='Выполнена' page='/office' />
                                //     </span>
                                // ) : (
                                //     <span>
                                //         <T textName='not_completed' defaultStr='Не выполнена' page='/office' />
                                //     </span>
                                // )
                                <span className={css.activityDoneColor}>
                                    <T textName='completed' defaultStr='Выполнена' page='/office' />
                                </span>
                            ) : (
                                <span>
                                    <T textName='not_completed' defaultStr='Не выполнена' page='/office' />
                                </span>
                            )}
                        </p>
                        <p className={css.infoDate}>
                            {info?.activity ? (
                                <T
                                    vars={{ end: transformActivityDate(activityCondition?.activity_date) }}
                                    textName='activity-activity_date-to'
                                    defaultStr='по ${end}'
                                    page='/office'
                                />
                            ) : activityCondition?.activity_date ? (
                                <T
                                    vars={{ end: transformActivityDate(activityCondition?.activity_date) }}
                                    textName='activity-activity_date-from'
                                    defaultStr='с ${end}'
                                    page='/office'
                                />
                            ) : (
                                ''
                            )}
                        </p>
                    </div>
                </div>
                <div className={css.activityProgress}>
                    <div className={css.activityProgressText}>
                        {activityCondition?.personal_volume ? (
                            <p className={css.activityProgressLabel}>
                                <T textName='to-prolong-activity' defaultStr='Для продолжения активности' page='/office' />:
                            </p>
                        ) : null}

                        <div className={css.activityProgressValueWrapper}>
                            {activityCondition?.personal_volume ? (
                                <p className={css.activityProgressValue}>
                                    {`${(+activityCondition?.personal_volume?.value >= +activityCondition?.personal_volume?.target
                                        ? +activityCondition?.personal_volume?.target
                                        : +activityCondition?.personal_volume?.value || 0
                                    ).toLocaleString()} ${t('of', 'из', '/office', translation)} ${(
                                        +activityCondition?.personal_volume?.target || 0
                                    ).toLocaleString()} ${t('LO', 'ЛО', 'all', translation)}`}
                                </p>
                            ) : null}
                            <Tooltip
                                showModal={true}
                                modalText={
                                    <div className={css.activityModalText}>
                                        <p>
                                            <T
                                                textName='office-activity-tooltip-1-v1'
                                                defaultStr='Для восстановления активности вы можете'
                                                page='/office'
                                            />{' '}
                                            <strong>
                                                <T
                                                    textName='office-activity-tooltip-1-1'
                                                    defaultStr='приобрести продукцию в интернет-магазине'
                                                    page='/office'
                                                />
                                            </strong>{' '}
                                            <T textName='office-activity-tooltip-1-2' defaultStr='проекта или' page='/office' />{' '}
                                            <strong>
                                                <T
                                                    textName='office-activity-tooltip-1-3'
                                                    defaultStr='использовать Личный объём PV'
                                                    page='/office'
                                                />
                                            </strong>
                                            .
                                        </p>
                                        <p>
                                            <T
                                                vars={{ value: pvValue }}
                                                textName='office-activity-tooltip-2-v1'
                                                defaultStr='Если за месячный отчетный период на ваш бонусный кошелек было зачислено вознаграждений на сумму ${value} и более вам необходимо оплатить активность'
                                                page='/office'
                                            />
                                            .
                                        </p>
                                        <p>
                                            <T
                                                textName='office-activity-tooltip-3-v1'
                                                defaultStr='Обратите внимание, что'
                                                page='/office'
                                            />{' '}
                                            <strong>
                                                <T
                                                    textName='office-activity-tooltip-3-1'
                                                    defaultStr='активность возобновляется с момента оплаты заказа'
                                                    page='/office'
                                                />
                                            </strong>{' '}
                                            <T
                                                textName='office-activity-tooltip-3-2'
                                                defaultStr='на соответствующее количество PV или списания с Личного объёма и'
                                                page='/office'
                                            />{' '}
                                            <strong>
                                                <T
                                                    textName='office-activity-tooltip-3-3'
                                                    defaultStr='действует в течение следующего месячного отчетного периода'
                                                    page='/office'
                                                />
                                            </strong>
                                            .
                                        </p>
                                    </div>
                                }
                            >
                                <div className={css.tooltip}>
                                    {svgSprite('question-circle-fill', {
                                        className: classNames(css.tooltipIcon, 'tooltipShadow')
                                    })}
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default function OfficeActivity(props) {
    const { activity, customCss } = props;

    return (
        <Skeleton
            Component={RenderData}
            componentProps={{ activity, customCss }}
            wait={!!activity}
            pattern={skeleton}
            wrapperStyles={css.skeleton}
            lazy={true}
        />
    );
}
